export default __webpack_public_path__ + "static/mst_logo_2-1-14f3db795fe65cdc3dccd01640c23c8c.png";